import api from '../api';

function newProfessional() {
    return {
        id: 0,
        title: '',
        name: '',
        schedule: Array(7).fill([]),
        specialties: [],
        gaps: [],
    };
}

async function fetchProfessionals(params) {
    const response = await api.get('professionals', { params });
    return response.data;
}

async function fetchProfessional(id) {
    const response = await api.get(`professional/${id}`);
    return response.data;
}

export { newProfessional, fetchProfessionals, fetchProfessional };
